"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

/**
 * outil pour découpage d'une zone rectangulaire
 * Trigger:
 */
module.exports = Backbone.View.extend({

    className: "overlay overlay-select",
    model: null, // PageModel
    minWidth: 0,
    maxWidth: 100,
    minHeight: 0,
    maxHeight: 100,
    events: {
        "pointerdown": "onDragStart",
        "touchstart": "onDragStart"
    },
    hasPointerEvent: false,

    initialize: function (options) {
        var T = this;

        T.selection = {
            x: 30,
            y: 30,
            width: 40,
            height: 40
        };

        _.extend(T, options);

        T.hasPointerEvent = window.PointerEvent ? true : false;

        T._pointers = {};
        T._dragStartPoint = { x: 0, y: 0 };
        T._dragStartSelection = {};
        T._abortDrag = false;

        if (T.hide) {
            T.$el.addClass("hide");
        }

        if (!T.pageModel.fetched) {
            T.listenToOnce(T.pageModel, "sync", T.render);
        }
        else {
            T.render();
        }
    },

    render: function () {
        var T = this,
            d = "<div/>";

        T.$el.html("");

        if (T.pageModel.fetched) {
            T.$cacheTop = $(d, {
                class: "cache top",
            });
            T.$el.append(T.$cacheTop);
            T.$cacheLeft = $(d, {
                class: "cache left",
            });
            T.$el.append(T.$cacheLeft);
            T.$cacheRight = $(d, {
                class: "cache right",
            });
            T.$el.append(T.$cacheRight);
            T.$cacheBottom = $(d, {
                class: "cache bottom",
            });
            T.$el.append(T.$cacheBottom);

            T.$handleCenter = $(d, {
                class: "handle center",
            });
            T.$handleCenter.data("handle", "center");
            T.$el.append(T.$handleCenter);

            T.$handleLeft = $(d, {
                class: "handle left",
            });
            T.$handleLeft.data("handle", "left");
            T.$el.append(T.$handleLeft);

            T.$handleTop = $(d, {
                class: "handle top",
            });
            T.$handleTop.data("handle", "top");
            T.$el.append(T.$handleTop);

            T.$handleRight = $(d, {
                class: "handle right",
            });
            T.$handleRight.data("handle", "right");
            T.$el.append(T.$handleRight);

            T.$handleBottom = $(d, {
                class: "handle bottom",
            });
            T.$handleBottom.data("handle", "bottom");
            T.$el.append(T.$handleBottom);

            T.layout();
        }
    },

    _clampWidth: function (width) {
        var T = this;
        if (width < T.minWidth) {
            width = T.minWidth;
        } else if (width > T.maxWidth) {
            width = T.maxWidth;
        }
        return width;
    },

    _clampHeight: function (height) {
        var T = this;
        if (height < T.minHeight) {
            height = T.minHeight;
        } else if (height > T.maxHeight) {
            height = T.maxHeight;
        }
        return height;
    },

    setSelection: function (new_sel, clamp) {
        var T = this,
            x = new_sel.x,
            y = new_sel.y,
            height = new_sel.height,
            width = new_sel.width;

        if (clamp) {
            // clamp size
            width = T._clampWidth(width);
            height = T._clampHeight(height);

            // clamp position
            if (x < 0) {
                x = 0;
            }
            if (y < 0) {
                y = 0;
            }
            if (x + width > 100) {
                width = 100 - x;
            }
            if (y + height > 100) {
                height = 100 - y;
            }
        }

        T.selection.x = x;
        T.selection.y = y;
        T.selection.width = width;
        T.selection.height = height;
        T.layout();
    },

    layout: function () {
        var T = this;

        // place each cache and handles
        T.$cacheTop.css({
            height: T.selection.y + "%"
        });
        T.$cacheBottom.css({
            top: (T.selection.y + T.selection.height) + "%",
            height: (100 - T.selection.height - T.selection.y) + "%"
        });
        T.$cacheLeft.css({
            top: T.selection.y + "%",
            height: T.selection.height + "%",
            width: T.selection.x + "%"
        });
        T.$cacheRight.css({
            top: T.selection.y + "%",
            height: T.selection.height + "%",
            width: (100 - T.selection.x - T.selection.width) + "%"
        });
        T.$handleCenter.css({
            top: (T.selection.y + (T.selection.height / 2)) + "%",
            left: (T.selection.x + (T.selection.width / 2)) + "%"
        });
        T.$handleLeft.css({
            top: (T.selection.y + (T.selection.height / 2)) + "%",
            left: T.selection.x + "%"
        });
        T.$handleRight.css({
            top: (T.selection.y + (T.selection.height / 2)) + "%",
            left: T.selection.x + T.selection.width + "%"
        });
        T.$handleTop.css({
            top: T.selection.y + "%",
            left: T.selection.x + (T.selection.width / 2) + "%"
        });
        T.$handleBottom.css({
            top: (T.selection.y + T.selection.height) + "%",
            left: T.selection.x + (T.selection.width / 2) + "%"
        });

    },

    onDragStart: function (e) {
        var T = this, new_page_x, new_page_y;

        if (T.$el.hasClass("inactive")) {
            return;
        }

        if (e.type == "touchstart" && T.hasPointerEvent) return; // ignore les events touch si le navigateur supporte les pointers events

        e.preventDefault();
        e.stopPropagation();

        var nb_touches_before = Object.keys(T._pointers).length;

        if (T.hasPointerEvent) {
            T._pointers[e.originalEvent.pointerId] = {
                pageX: e.pageX,
                pageY: e.pageY
            };
            new_page_x = e.pageX;
            new_page_y = e.pageY;
        }
        else {
            var touches = e.originalEvent.changedTouches;
            for (var i = 0; i < touches.length; i++) {
                T._pointers[touches[i].identifier] = {
                    pageX: touches[i].pageX,
                    pageY: touches[i].pageY
                };
            }
            new_page_x = touches[0].pageX;
            new_page_y = touches[0].pageY;
        }

        var keys = _.keys(T._pointers);

        if (keys.length == 1) {
            T._dragStartPoint.x = new_page_x;
            T._dragStartPoint.y = new_page_y;

            T._dragHandle = $(e.target).data("handle");
            if (T._dragHandle) {
                // handle drag
                T._dragStartSelection = _.clone(T.selection);
            }
            else {
                // new selection
                var offset = T.$el.offset(),
                    page_x = (new_page_x - offset.left) * 100 / T.$el.width(),
                    page_y = (new_page_y - offset.top) * 100 / T.$el.height();
                T._dragStartSelection.x = page_x;
                T._dragStartSelection.y = page_y;
                T._dragStartSelection.width = T.minWidth;
                T._dragStartSelection.height = T.minHeight;
            }
            T.trigger("select:start");
        }
        else {
            T._abortDrag = true;
        }

        if (nb_touches_before == 0) {
            if (T.hasPointerEvent) {
                $(window).on("pointermove.ov-sel", function (e) { T.onDragMove(e); });
                $(window).on("pointerup.ov-sel", function (e) { T.onDragEnd(e); });
                $(window).on("pointercancel.ov-sel", function (e) { T.onDragEnd(e); });
            }
            else {
                $(window).on("touchmove.ov-sel", function (e) { T.onDragMove(e); });
                $(window).on("touchend.ov-sel", function (e) { T.onDragEnd(e); });
                $(window).on("touchcancel.ov-sel", function (e) { T.onDragEnd(e); });
            }
        }

    },

    onDragMove: function (e) { //jshint ignore: line
        var T = this, new_page_x, new_page_y;

        if (T._abortDrag) return;

        //console.log("drag move doc "+e.type);
        if (T.hasPointerEvent) {
            T._pointers[e.originalEvent.pointerId] = {
                pageX: e.pageX,
                pageY: e.pageY
            };
            new_page_x = e.pageX;
            new_page_y = e.pageY;
        }
        else {
            var touches = e.originalEvent.changedTouches;
            for (var i = 0; i < touches.length; i++) {
                T._pointers[touches[i].identifier] = {
                    pageX: touches[i].pageX,
                    pageY: touches[i].pageY
                };
            }
            new_page_x = touches[0].pageX;
            new_page_y = touches[0].pageY;
        }

        var keys = _.keys(T._pointers);
        if (keys.length == 1) {
            var dX = (new_page_x - T._dragStartPoint.x) * 100 / T.$el.width(), // %
                dY = (new_page_y - T._dragStartPoint.y) * 100 / T.$el.height(), // %
                clamp = false;

            //console.log("dx: "+dX);

            var new_sel = _.clone(T._dragStartSelection);

            if (T._dragHandle) {
                if (T._dragHandle == "center") {
                    new_sel.x = T._dragStartSelection.x + dX;
                    if (new_sel.x < 0) {
                        new_sel.x = 0;
                    }
                    if (new_sel.x + new_sel.width > 100) {
                        new_sel.x = 100 - new_sel.width;
                    }
                    new_sel.y = T._dragStartSelection.y + dY;
                    if (new_sel.y < 0) {
                        new_sel.y = 0;
                    }
                    if (new_sel.y + new_sel.height > 100) {
                        new_sel.y = 100 - new_sel.height;
                    }
                }
                else if (T._dragHandle == "left") {
                    new_sel.width = T._clampWidth(T._dragStartSelection.width - dX);
                    new_sel.x = T._dragStartSelection.x + T._dragStartSelection.width - new_sel.width;
                    if (new_sel.x < 0) {
                        new_sel.x = 0;
                        new_sel.width = T._dragStartSelection.width + T._dragStartSelection.x;
                    }
                }
                else if (T._dragHandle == "right") {
                    new_sel.width = T._clampWidth(T._dragStartSelection.width + dX);
                    if (T._dragStartSelection.x + new_sel.width > 100) {
                        new_sel.width = 100 - T._dragStartSelection.x;
                    }
                }
                else if (T._dragHandle == "top") {
                    new_sel.height = T._clampHeight(T._dragStartSelection.height - dY);
                    new_sel.y = T._dragStartSelection.y + T._dragStartSelection.height - new_sel.height;
                    if (new_sel.y < 0) {
                        new_sel.y = 0;
                        new_sel.height = T._dragStartSelection.height + T._dragStartSelection.y;
                    }
                }
                else if (T._dragHandle == "bottom") {
                    new_sel.height = T._clampHeight(T._dragStartSelection.height + dY);
                    if (T._dragStartSelection.y + new_sel.height > 100) {
                        new_sel.height = 100 - T._dragStartSelection.y;
                    }
                }
            }
            else {

                if (dX < 0) {
                    new_sel.x = T._dragStartSelection.x + dX;
                    if (new_sel.x >= 0) {
                        new_sel.width = -dX;
                    }
                    else {
                        new_sel.width = T.selection.width; // on dépasse le bord gauche, la taille ne bouge pas
                    }
                }
                else {
                    new_sel.width = dX;
                }

                if (dY < 0) {
                    new_sel.y = T._dragStartSelection.y + dY;
                    if (new_sel.y >= 0) {
                        new_sel.height = -dY;
                    }
                    else {
                        new_sel.height = T.selection.height; // on dépasse le bord haut, la taille ne bouge pas
                    }
                }
                else {
                    new_sel.height = dY;
                }

                clamp = true;
            }
            T.setSelection(new_sel, clamp);
        }

    },

    onDragEnd: function (e) {
        var T = this;

        if (T.hasPointerEvent) {
			delete T._pointers[e.originalEvent.pointerId];
		}
		else {
			var touches = e.originalEvent.changedTouches;
			for (var i = 0; i < touches.length; i++) {
				delete T._pointers[touches[i].identifier];
			}
		}

        var keys = _.keys(T._pointers);

        //console.log("drag end doc "+e.type);
        if (!keys.length) {
            $(window).off(".ov-sel");
            T._abortDrag = false;
            T.trigger("select:end");
            //T.$el.removeClass("grabbing");
        }
    },

    close: function () {
        var T = this;
        T.stopListening();
        T.undelegateEvents();
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@immanens-com/pv5js/reader/views/overlay-select-view.js
// module id = 50
// module chunks = 0